import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import FileUploadCompnent from './components/FileUpload';
import { ToastContainer } from 'react-toastify';
export const queryClient = new QueryClient();
const FileUpload = ({ setOpenUploadFilePopup, object_id }: any) => {
  return (
    <QueryClientProvider client={queryClient}>
      <FileUploadCompnent
        setOpenUploadFilePopup={setOpenUploadFilePopup}
        object_id={object_id}
      />
      <ToastContainer autoClose={2000} draggablePercent={30} />
    </QueryClientProvider>
  );
};
export { FileUpload };
